import React from 'react';
import { useSaveShortcut } from '../../../hooks/useSaveShortcut';

export const FormSaveShortcut: React.FC<{
  onSave: () => void;
  enabled: boolean;
}> = ({ onSave, enabled }) => {
  useSaveShortcut(onSave, enabled);
  return null;
};
